/**
 * 命名空间管理模块
 * 提供嵌套命名空间创建功能，避免全局变量污染
 * 
 * @module namespace
 * @author wei<innereyecw@gmail.com>
 * @version 5.0.0
 */
(function (global) {
  "use strict";

  /**
   * 创建嵌套命名空间
   * @param {string} namespaces - 点分命名空间字符串，如 "watashi.common.utils"
   * @returns {Object} 最内层的命名空间对象
   * 
   * @example
   * // 创建 watashi.common 命名空间
   * const common = namespace("watashi.common");
   * common.myMethod = function() { ... };
   * 
   * @example
   * // 创建深层命名空间
   * const utils = namespace("watashi.common.utils.format");
   * utils.numberFormat = function(num) { ... };
   */
  const namespace = (namespaces) => {
    const parts = namespaces.split('.');
    let current = global;
    
    for (const part of parts) {
      // 如果命名空间不存在则创建空对象
      current[part] = current[part] || {};
      current = current[part];
    }
    
    return current;
  };

  // ==================== 初始化根命名空间 ====================
  const watashi = namespace("watashi");
  namespace("watashi.core");
  namespace("watashi.common");
  namespace("watashi.maps");

  // ==================== 暴露到核心模块 ====================
  if (global.watashi && global.watashi.core) {
    global.watashi.core.namespace = namespace;
  }

  // ==================== 全局暴露 ====================
  // 仅在 noGlobal 未定义时挂载到全局对象
  if (typeof noGlobal === "undefined") {
    global.watashi = watashi;
  }

})(typeof window !== "undefined" ? window : {});